import { mapGenericModalProperties } from '@legacy/common-ui-shared';
import { GenericModalSources } from '@legacy/common-ui-shared-interfaces';
import type {
  InsulationFunnelSettingsFields,
  InsulationFunnelSettingsInterface,
} from '@innogy/feh/models';

export function mapInsulationFunnelSettingsFields(
  funnelSettingsFromSitecore: InsulationFunnelSettingsFields | null | undefined
): InsulationFunnelSettingsInterface | undefined {
  if (!funnelSettingsFromSitecore?.fields) {
    return undefined;
  }

  const {
    StartPage,
    SuccessPage,
    OrderPage,
    ProductOverviewPage,
    AlreadyInsulatedPage,
    NoProductsAvailablePage,
    GenericErrorModal,
    AddressNotFoundErrorModal,
  } = funnelSettingsFromSitecore.fields;

  return {
    id: funnelSettingsFromSitecore.id,
    startPage: StartPage?.value,
    productOverviewPage: ProductOverviewPage?.value,
    orderPage: OrderPage?.value,
    successPage: SuccessPage?.value,
    alreadyInsulatedPage: AlreadyInsulatedPage?.value,
    noProductsAvailablePage: NoProductsAvailablePage?.value,
    genericErrorModal: mapGenericModalProperties(
      GenericModalSources.GENERIC_ERROR_MODAL,
      GenericErrorModal?.fields
    ),
    addressNotFoundErrorModal: mapGenericModalProperties(
      GenericModalSources.ADDRESS_NOT_FOUND_ERROR_MODAL,
      AddressNotFoundErrorModal?.fields
    ),
  };
}
